import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";
import { UserRoles } from "@coworker/apprestructured/src/shared/enums/user/userRoles";

export const displayRoleTranslationString = (role: UserRoles) => {
  switch (role) {
    case UserRoles.COUNTRY_SUPERUSER:
      return "countrySuperuserString";
    case UserRoles.SUPERUSER:
      return "globalSuperuserString";
    case UserRoles.STOREOWNER:
      return "storeSuperuserString";
    case UserRoles.COWORKER:
    default:
      return "coworkerString";
  }
};

const displayAtkomstRoleTranslationString = (roles: string[]) => {
  if (roles.includes("Fixa Super User")) {
    return "atkomstSuperUserString";
  }
  return "atkomstCoworkerString";
};

export const useDisplayRoleTranslationString = ({
  roleId,
  atkomstRoles,
}: {
  roleId?: UserRoles;
  atkomstRoles?: string[];
}) => {
  const enabledAtkomst = useFlag(FLAGS.ENABLE_ATKOMST);

  if (enabledAtkomst && atkomstRoles) {
    return displayAtkomstRoleTranslationString(atkomstRoles);
  }
  if (roleId) {
    return displayRoleTranslationString(roleId);
  }
  return "";
};
